// Spec: .github/specs/maintenance-mode-fe.md

import {
  DEFAULT_AUTO_REFRESH_INTERVAL_SECONDS,
  DEFAULT_CONTACT_SUPPORT_EMAIL,
  DEFAULT_RESTORATION_MESSAGE,
} from './maintenance-status.config';

export {
  DEFAULT_AUTO_REFRESH_INTERVAL_SECONDS,
  DEFAULT_CONTACT_SUPPORT_EMAIL,
  DEFAULT_RESTORATION_MESSAGE,
};

// Raw backend shape (Newtonsoft PascalCase, not auto-mapped to camelCase)
export interface MaintenanceStatusApiResponse {
  Enabled: boolean;
  RestorationMessage: string;
  ContactSupportEmail: string;
  AutoRefreshIntervalSeconds: number;
}

export interface MaintenanceStatus {
  enabled: boolean;
  restorationMessage: string;
  contactSupportEmail: string;
  autoRefreshIntervalSeconds: number;
}

/**
 * Maps the PascalCase backend response to the FE camelCase model.
 * @param response raw API response
 * @returns mapped maintenance status
 */
export function mapMaintenanceStatus(
  response: MaintenanceStatusApiResponse,
): MaintenanceStatus {
  return {
    enabled: !!response?.Enabled,
    restorationMessage:
      response?.RestorationMessage ?? DEFAULT_RESTORATION_MESSAGE,
    contactSupportEmail:
      response?.ContactSupportEmail ?? DEFAULT_CONTACT_SUPPORT_EMAIL,
    autoRefreshIntervalSeconds:
      response?.AutoRefreshIntervalSeconds ??
      DEFAULT_AUTO_REFRESH_INTERVAL_SECONDS,
  };
}
